export const K8S_CLUSTER_STATE = {
  ACTIVE: 'ACTIVE',

};
